<div class="row justify-content-center">
  <div class="col-md-8 col-lg-8 col-12">
    <h3>{{ "accounts.phone_change.title" | translate }}</h3>

    <div class="card justify-content-center mb-2 p-0" style="border-color: var(--info); border-radius: 15px">
      <div class="row no-gutters">
        <div class="col-2 col-sm-1 d-flex justify-content-center align-items-center p-0 m-0">
          <i class="fa fa-lg text-info fa-info-circle"></i>
        </div>

        <div class="col-10 col-sm-11 d-flex justify-content-center align-items-center p-0 m-0">
          <div class="card-body p-0">
            <p class="card-text responsive-small text-info" style="font-size: 16px">
              {{ "accounts.phone_change.info" | translate }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <form #form="ngForm" (ngSubmit)="form.form.valid && generateRecaptcha()" novalidate>

      <div class="col-12 mb-3">
        <label>{{ "accounts.phone_change.new_number" | translate }}</label>
        <div class="input-group">
          <img [src]="getDialCodePhoneData(phoneCountryCode, configurationService.application).flag" class=" m-1 input-group-prepend" height="30" alt="mx">
          <input type="tel" class="input-group form-control" [mask]="getDialCodePhoneData(phoneCountryCode, configurationService.application).mask" name="cellphone" [(ngModel)]="phoneNumber" #cellphone="ngModel" [ngClass]="inputFieldCss(cellphone, form)" numbers required>
        </div>
        <div class="mt-1 bottom text-md-right text-center">
          <small class="text-sm-center">{{ "accounts.phone_change.not_usa_phone" | translate }} <span class="text-primary" style="cursor: pointer" (click)="openModal(countryCode)">{{ "accounts.phone_change.here" | translate }}</span></small>
        </div>
      </div>

      <div class="col-12">
        <div class="form-group">
          <label>{{ "accounts.phone_change.enter_password" | translate }}</label>
          <div class="input-group">
            <div class="input-group-append">
              <button [ngClass]="showPassword ? 'btn rounded-left btn-outline-success' : 'btn rounded-left btn-outline-primary'" type="button"
                      (click)="this.showPassword = !this.showPassword"><i [ngClass]="showPassword ? 'fas fa-eye' : 'fas fa-eye-slash'"></i></button>
            </div>
            <input [type]="showPassword ? 'text' : 'password'" class="form-control" name="password" [(ngModel)]="password" #passwordVal="ngModel" [ngClass]="inputFieldCss(passwordVal, form)" [minLength]="6" [readOnly]="waitingOtp" required>
          </div>
          <div class="text-right">
            <label style="font-size: small">{{ "shared.login.show-password" | translate }}</label>
            <input class="ml-2" type="checkbox" name="newNip2" value="nip" [(ngModel)]="showPassword">
          </div>
          <app-field-error-display [control]="passwordVal" [form]="form"></app-field-error-display>
        </div>
      </div>
      <div class="col-12 text-right mb-2">
        <button type="submit" class="btn btn-primary" [disabled]="!form.form.valid">{{ "accounts.phone_change.send_code" | translate }}</button>
      </div>
      <div *ngIf="waitingOtp" class="row mt-3 justify-content-center">
        <div class="col">
          <p>{{ "accounts.phone_change.enter_code" | translate }}</p>
          <div class="col-12 text-center">
            <label>{{ "accounts.phone_change.verification_code" | translate }}</label>
            <small class="text-danger required">{{ "accounts.phone_change.required_field" | translate }}</small>
            <ng-otp-input (onInputChange)="validateCellPhone($event, form)" [config]="{length:otpLength, allowNumbersOnly:true}"></ng-otp-input>
          </div>
        </div>
      </div>
    </form>
  </div>

</div>


<ng-template #countryCode let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="countryCodeTitle">{{ "accounts.phone_change.country_code" | translate }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body justify-content-center text-center">
    <select class="custom-select" name="phoneCountryCode" [(ngModel)]="phoneCountryCode" #countryCode="ngModel" (ngModelChange)="modal.dismiss()" required>
      <option *ngFor="let c of countryCodes" [ngValue]="c.dialCode">+{{c.dialCode}} ({{c.name}})</option>
    </select>
  </div>
</ng-template>
